module.exports = __webpack_public_path__ + "img/music-work-icon11.3a8d2c93.png";